import React, { useState, useEffect, useRef } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import {
  Stack,
  Button,
  IconButton,
  Box,
  Grid,
  Card,
  CardContent,
  CardActions,
  Paper,
  CircularProgress,
  Popover,
  Typography,
  Divider,
  MenuItem,
  List,
  ListItem,
  ListItemButton,
  ListItemAvatar,
  ListItemText,
} from '@mui/material'
import client from '../common/client'
import AceEditor from 'react-ace'
import 'brace/ext/searchbox'
import 'ace-builds/src-noconflict/mode-java'
import 'ace-builds/src-noconflict/theme-github'
import toast, { Toaster } from 'react-hot-toast'
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart'
import AddIcon from '@mui/icons-material/Add'
import SettingsIcon from '@mui/icons-material/Settings';

const IDENewScreen = props => {
  const navigate = useNavigate();
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    update()
  }, [])

  const update = () => {
    client.request_get('/api/sketch/candidate').then(list => {
      let new_list = []
      list.map(m => {
        m.new_screen_list.map(s => {
          s.sketch_id = m.id
          s.sketch_name = m.name
          new_list.push(s)
        })
      })
      setList(new_list)

    })
  }

  const onClickAdd = (m) => {
    list.find(f=>f.id == m.id).loading = true
    client.request_post('/api/engine/generate/'+m.sketch_id, {target_list:[m]}).then(r=>{
      list.find(f=>f.id == m.id).loading = false
      if(r.r){
        toast.success('Screen added')
        props.onChange(m.id)
        update()
      }else{
        toast.error(r.msg)
      }
    })
  }

  return (
    <Box sx={{ width: '100%', height: '100%', textAlign: 'center', }}>
      <Toaster position='bottom-center' reverseOrder={false} />
      <Typography sx={{ mt: 4, mb: 2 }} variant="h6" component="div">
        Add new screen
      </Typography>
      <List sx={{ width: '100%', maxWidth: 360, display: 'inline-block' }}>
        {list.map(m => (
          <ListItem secondaryAction={
            (m.loading ? <CircularProgress size={20} /> :
              <IconButton edge="end" onClick={()=>{onClickAdd(m)}}>
                <AddIcon />
              </IconButton>)
          }>
            <ListItemText primary={m.name} secondary={m.sketch_name} />
          </ListItem>
        ))}
      </List>
      <Stack mt={2} spacing={1}>
          {list.length == 0 && <Typography variant="body2" color="text.secondary">
            No screen to add<br/>
            Please, create new artboard in Sketch
            </Typography>}
      </Stack>
    </Box>
  )
}

export default IDENewScreen
